module.exports = __webpack_public_path__ + "img/whatsapp.0da764db.svg";